<!-- nav-button -->
<template>
  <div id='page'>
    <button class="nav-button" @click="$emit('click')" :class="{'bgcf':bgcf}">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  props: ['bgcf']
}
</script>
<style scoped lang='scss'>
.nav-button {
  // margin-top: 20px;
  width: 100px;
  height: 40px;
  padding: 0px 10px;
  border-radius: 100px;
  background: transparent;
  // line-height: 40px;
  color: #FF6D00;
  margin-left: 14px;
  border: 1px solid #FF6D00;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
    color: #fff;
    background: #FF6D00;
  }
  &.bgcf {
    color: #fff;
    background: #FF6D00;
    border-color: #FF6D00;
  }
}
@include isMobile {
  .nav-button {
    height: rem(80);
    margin-left: 0;
    position: fixed;
    left: rem(40);
    border-radius: rem(40);
    bottom: rem(238);
    width: rem(670);
    &:active {
      color: #fff;
      background: #FF6D00;
    }
  }
}
</style>
